<template>      
    <div class="screen">
      <Login></Login>
    </div>    
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({data() {return {}}});
</script>